import script from "./RefreshButton.vue?vue&type=script&setup=true&lang=js"
export * from "./RefreshButton.vue?vue&type=script&setup=true&lang=js"

import "./RefreshButton.vue?vue&type=style&index=0&id=8ecf4022&lang=scss&scoped=true"
script.__scopeId = "data-v-8ecf4022"

export default script